export default "__VITE_ASSET__DxMEJLup__"